import axios from '../utils/axiosConfig';
import { apiConfig } from '../config/api.config';

const getAuthToken = () => {
  return document.cookie.split(';').find(row => row.trim().startsWith('auth_token='))?.split('=')[1];
};

export const ticketService = {
  // 获取工单列表
  getTicketList: async (params) => {
    const auth_token = getAuthToken();
    const response = await axios.get(apiConfig.getFullURL('/ark/ticket/list'), {
      params: {
        auth_token,
        ...params
      }
    });
    return response.data;
  },

  // 获取工单统计
  getTicketCount: async (params) => {
    const auth_token = getAuthToken();
    const response = await axios.get(apiConfig.getFullURL('/ark/ticket/list/count'), {
      params: {
        auth_token,
        ...params
      }
    });
    return response.data;
  },

  // 导出工单列表
  exportTicketList: async (params) => {
    const auth_token = getAuthToken();
    const response = await axios.get(apiConfig.getFullURL('/ark/ticket/list'), {
      params: {
        auth_token,
        ...params,
        export: true
      }
    });
    return response.data;
  },

  // 审核工单
  auditTicket: async (auditorId , ticketId, status, memo) => {
    const auth_token = getAuthToken();
    const response = await axios.post(apiConfig.getFullURL('/ark/ticket/audit'), {
      auth_token,
      auditor_id:auditorId,
      ticket_id: ticketId,
      result:status,
      memo
    });
    return response.data;
  }
};